import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';
import enhanceWithClickOutside from 'react-click-outside';
import {notificationOpened, removeNotification} from '../actions/call';
import {connect} from 'react-redux';
import { uniqBy } from 'lodash';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";
const ESCAPE_KEY = 27;

class NotificationMenu extends Component {
	constructor(props) {
    super(props);
    this.state = {isShow: false};
    this.handleClick = this.handleClick.bind(this);
  }

	componentWillMount(){
    document.addEventListener("keydown", this.handleKeyDown);
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.closeMenu !== this.props.closeMenu && this.state.isShow){
			this.handleClickOutside();
		}
	}

	componentWillUnmount() {
	    document.removeEventListener("keydown", this.handleKeyDown);
	}

	getFilteredData = (missedCalls) => {
		return uniqBy(missedCalls, 'data.id');
	}

	// looks for escape key to close popover
	handleKeyDown = (event) => {
    switch( event.keyCode ) {
        case ESCAPE_KEY:
            this.handleClickOutside();
            break;
        default:
            break;
    }
	}
	// handles click on notification. and toggles its visibility
  handleClick() {
		this.props.notificationOpened();
    this.setState(function(prevState) {
      return {isShow: !prevState.isShow};
    });
  }

	// removes notification
	handleNotificationClose = (e) => {
		e.stopPropagation();
		const id = e.target.id;
		this.props.removeNotification(id);
	}

	// closes popover when clicked outside
	handleClickOutside = () => {
    if (this.state.isShow) {
			this.setState({
				isShow: !this.state.isShow
			})
		}
  }
	render() {
		const {
			translations,
			selectedLanguage,
			missedCalls,
			notificationCount,
			showNotificationCount,
			agentInfo,
		} = this.props;
		const filteredMissedCalls = this.getFilteredData(missedCalls);
		return (
      <li className={ `${this.state.isShow ? 'dropdown open': 'dropdown'} notificationsMenu` } onClick={this.handleClick}>
        <a href={undefined} className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={ this.state.isShow ? 'true': 'false' }>
          <span className="icon icon-notification padding_right_5" />
          {translations.notifications[selectedLanguage]}
          {(showNotificationCount && notificationCount > 0) && <Badge style={{
						position: 'absolute', right: 3, top: 3}}>{notificationCount}</Badge>}
        </a>

        <ul className={`dropdown-menu dropdown-menu${this.props.theme} notification-list`}>
					{filteredMissedCalls.length > 0 && filteredMissedCalls.map((item, key) => (
          <li key={ `${item.data.id}_${key}` }>
            <div className="media">
              <div className={`media-body divtext${this.props.theme}`}>
								<span
									className="icon icon-circle-with-cross close-tab notificaion-close"
									id={item.data.id}
									onClick={this.handleNotificationClose}
								/>
                {translations.missedCall1[selectedLanguage]} {item.data.from} {item.data.service_name? (translations.missedCall2[selectedLanguage] + " " + item.data.service_name) : ""}
								<div className="small text-muted">{item.data.time}</div>
              </div>
            </div>
          </li>
					))}
					{missedCalls.length === 0 &&
						<li className={`notification-footer${this.props.theme}`}>
	            <a className="text-center" data-toggle="modal" data-target="#notificationsModal">{translations.noNotifications[selectedLanguage]}</a>
	          </li>
					}
          {/* <li className="dismissable notification-warning">
            <div className="media">
              <div className="media-body">
                <h4 className="media-heading">Lorem ipsum</h4>
                Lorem ipsum dolor sit amet
                <div className="small text-muted"><strong>Lorem ipsum,</strong> 27 de julio, 18:30h</div>
                <button type="button" className="close notification-dismiss"><span className="icon icon-circle-with-cross"></span></button>
              </div>
            </div>
          </li>
          <li className="dismissable notification-danger">
            <div className="media">
              <div className="media-body">
                <h4 className="media-heading">Lorem ipsum</h4>
                Lorem ipsum dolor sit amet
                <div className="small text-muted"><strong>Lorem ipsum,</strong> 27 de julio, 18:30h</div>
                <button type="button" className="close notification-dismiss"><span className="icon icon-circle-with-cross"></span></button>
              </div>
            </div>
          </li> */}
          {/* <li className="notification-footer">
            <a href className="text-center" data-toggle="modal" data-target="#notificationsModal">Ver las 4 notificaciones</a>
          </li> */}
        </ul>
      </li>
	  );
	}
}

function mapStateToProps  (state) {
    return {
				agentInfo: state.agentInfo,
				missedCalls: state.callEvents.missedCalls,
				notificationCount: state.callEvents.notificationCount,
				showNotificationCount: state.callEvents.showNotificationCount,
				closeMenu: state.common.closeMenu,
				translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
				darkMode: state.common.darkMode,
				theme: state.common.theme,
    };
}

const mapDispatchToProps = {
	notificationOpened,
	removeNotification
}

export default connect(mapStateToProps, mapDispatchToProps)(enhanceWithClickOutside(NotificationMenu));



// WEBPACK FOOTER //
// ./src/agent/notification-menu.js